"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = exports.getDidTickOverFlame = exports.getFrameCounter = void 0;
var diveColors_1 = require("@dive/colors/diveColors");
var sprites_sidecar_1 = require("@sprites/sprites-sidecar");
var minigolfCamera_sidecar_1 = require("../camera/minigolfCamera-sidecar");
var spritesBattlescapeFloor_1 = require("../recyclers/spritesBattlescapeFloor");
var spritesBattlescapeRoof_1 = require("../recyclers/spritesBattlescapeRoof");
var common_sidecar_1 = require("@main/common-sidecar");
var _frameCounterTimer = 0;
var _frameCounter = 0;
var _frameFlameCounterTimer = 0;
// let _frameFlameCounter = 0
var _didTickOverFlame = false;
var getFrameCounter = function () {
    return _frameCounter;
};
exports.getFrameCounter = getFrameCounter;
var getDidTickOverFlame = function () {
    return _didTickOverFlame;
};
exports.getDidTickOverFlame = getDidTickOverFlame;
var render = function (m) {
    var size = 40;
    var imgScale = 0.5;
    var tileScale = 0.51;
    var cc = minigolfCamera_sidecar_1.minigolfCamera.getCameraXY();
    var cam = {
        x: cc.cx,
        y: cc.cy, //-50,
    };
    _frameCounterTimer += common_sidecar_1.common.getUpdateDelta();
    var frameTime = 0.5;
    if (_frameCounterTimer > frameTime) {
        _frameCounter++;
        _frameCounterTimer -= frameTime;
    }
    var frameTimeFlame = 1 / 15;
    _frameFlameCounterTimer += common_sidecar_1.common.getUpdateDelta();
    if (_frameFlameCounterTimer > frameTimeFlame) {
        _frameFlameCounterTimer -= frameTimeFlame;
        _didTickOverFlame = true;
    }
    else {
        _didTickOverFlame = false;
    }
    // let thirds = _frameCounter % 3
    for (var iSection = 0; iSection < m.sections.length; iSection++) {
        var section = m.sections[iSection];
        for (var iTile = 0; iTile < section.tiles.length; iTile++) {
            var tile = section.tiles[iTile];
            var frame = sprites_sidecar_1.sprites.wargamesProtoGriddedSpace[0];
            var frame2 = null;
            var isFrame2High = true;
            var c = diveColors_1.diveColors.pureWhite;
            if (tile.color) {
                c = tile.color;
            }
            if (tile.tileIdx === -1) {
                // Override color
                // c = diveColors.green
                c = diveColors_1.diveColors.pureWhite;
                // frame = sprites.minigolfFloorExterior[0]
                frame = sprites_sidecar_1.sprites.minigolfFloorGrass2[0];
            }
            if (tile.tileIdx === 0) {
                // Override color
                // c = diveColors.green
                c = diveColors_1.diveColors.pureWhite;
                frame = sprites_sidecar_1.sprites.minigolfFloor[0];
            }
            if (tile.tileIdx === 52) {
                // Override color
                frame = sprites_sidecar_1.sprites.wargamesProtoSquare[0];
            }
            // Highground
            if (tile.tileIdx === 34 ||
                tile.tileIdxUp === 34 ||
                tile.tileIdx === 40 ||
                tile.tileIdxUp === 40) {
                c = diveColors_1.diveColors.pureWhite;
                frame = sprites_sidecar_1.sprites.minigolfFloorHighground[0];
            }
            if (tile.tileIdxUp === 5) {
                // Starting stairs
                c = diveColors_1.diveColors.pureWhite;
                frame2 = sprites_sidecar_1.sprites.minigolfStairsUpStart[0];
                isFrame2High = false;
            }
            // Tunnel over
            if (tile.tileIdxUp === 2) {
                frame2 = sprites_sidecar_1.sprites.minigolfTunnelRoof[0];
            }
            // Foliage
            if (tile.tileIdxUp === 157) {
                frame2 = sprites_sidecar_1.sprites.minigolfTree[0];
            }
            if (tile.tileIdxUp === 158) {
                frame2 = sprites_sidecar_1.sprites.minigolfBush[0];
            }
            var imgBack = spritesBattlescapeFloor_1.spritesBattlescapeFloor.getNext(tile.tx * size - cam.x, tile.ty * size - cam.y, sprites_sidecar_1.sprites.wargamesProtoSquare[0]);
            imgBack.scale = imgScale;
            imgBack.tint = diveColors_1.diveColors.pureBlack;
            var img = spritesBattlescapeFloor_1.spritesBattlescapeFloor.getNext(tile.tx * size - cam.x, tile.ty * size - cam.y, frame);
            img.scale = tileScale;
            img.tint = c;
            if (frame2) {
                if (isFrame2High) {
                    var img2 = spritesBattlescapeRoof_1.spritesBattlescapeRoof.getNext(Math.floor(tile.tx * size - cam.x), Math.floor(tile.ty * size - cam.y), frame2);
                    img2.scale = imgScale;
                }
                else {
                    var img2 = spritesBattlescapeFloor_1.spritesBattlescapeFloor.getNext(Math.floor(tile.tx * size - cam.x), Math.floor(tile.ty * size - cam.y), frame2);
                    img2.scale = imgScale;
                }
            }
            // if (tile.tileIdxUp === 2) {
            //   // Override color
            //   frame = sprites.minigolfTunnelRoof[0]
            //   let img = spritesBattlescapeRoof.getNext(
            //     tile.tx * size - cam.x,
            //     tile.ty * size - cam.y,
            //     frame,
            //   )
            //   img.scale = imgScale
            //   // img.tint = c
            // }
        }
    }
};
exports.render = render;
